import { Injectable } from "@angular/core";
import { Headers, Http, RequestOptions, Response } from "@angular/http";
import { AuthenticationService } from "../authentication.service";
import { EnvironmentService } from "../index";
import { BehaviorSubject, Observable } from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { Customer } from "../../_models/customer";
import { Car } from "../../_models/car";

@Injectable()
export class ServiceIntervalsService {
  private serviceIntervalBaseUrl: string =
    this.environmentService.getBaseURL() + 
    "/api" + 
    "/interval-calculator/next-service-date";
  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService
  ) {}

  calculateMatchedCustomer(dbCustomer: Customer): Observable<Customer> {
    var sentCust = {
      _id: dbCustomer._id,
      car: dbCustomer.car,
      dealer: dbCustomer.dealer,
      last_service_km_date: dbCustomer.last_service_km_date,
      carKmStand: dbCustomer.carKmStand,
      firstreg: dbCustomer.firstreg,
    }
    return this.http
      .post(
        `${this.serviceIntervalBaseUrl}`,
        JSON.stringify(
          sentCust
        ),
        this.makeHeaders()
      )
      .map((response: Response) => response.json());
  }




  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("Content-Type", "application/json ");
    headers.append("charset", "UTF-8 ");
    headers.append("Accept", "application/json ");

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}
function toCustomer(dbCustomer: Customer, r: any): Customer {
  dbCustomer.service_estimate = new Date(r.service_estimate);
  return dbCustomer;
}
function mapCustomer(dbCustomer: Customer, response: Response): Customer {
  // toPerson looks just like in the previous example
  var json = response.json();
  return toCustomer(dbCustomer, json);
}



// WEBPACK FOOTER //
// ./src/app/_services/interval/service-intervals.service.ts